import type { WidgetAction } from '@shared/conversation-schema';
import { Button } from '@/components/ui/button';

interface WidgetActionBarProps {
  actions: WidgetAction[];
  widgetId: string;
  onAction?: (
    widgetId: string,
    action: string,
    payload?: Record<string, unknown>,
    meta?: { text?: string; label?: string },
  ) => void;
}

const variantMap = {
  primary: 'default',
  secondary: 'secondary',
  ghost: 'ghost',
} as const;

export function WidgetActionBar({ actions, widgetId, onAction }: WidgetActionBarProps) {
  if (actions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {actions.map((action) => (
        <Button
          key={action.action}
          variant={variantMap[action.variant ?? 'secondary']}
          size="sm"
          onClick={() =>
            onAction?.(widgetId, action.action, action.payload as Record<string, unknown> | undefined, {
              text: action.text,
              label: action.label,
            })
          }
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
}
